import { useRouter } from "next/router";
import styled from "styled-components";
import { ImageWrapper } from "./styles";
import { useContext } from "react";
import { Context } from "@components/useContext/context";
import { resolvePath } from "@utils/resolvePath";

export interface ISDUIImgProps {
    is_visible: boolean;
    src: string;
    height?: string;
    width?: string;
    margin?: string;
    styles?: any;
    actions: any;
    id: string;
    alt: string;
    mStyles?: any;
    isResolvePath?: any
    desktopImgSrc?: string;
}

export const Img = styled.img`
  ${(props: any) => props.margin && `margin:${props.margin}`};
  ${(props: any) => props.height && `height:${props.height}`};
  ${(props: any) => props.width && `width:${props.width}`};
  ${(props: any) => props.styles};
`;

export function SDUIImageTag(props: ISDUIImgProps) {
    const { id, src, styles, actions, alt, mStyles, isResolvePath = false,desktopImgSrc ,is_visible} = props;
    const { on_click } = actions;
    const router = useRouter();
    const { isDesktop } = useContext(Context);
    let updatedImgSrc = src;
    if (isDesktop && desktopImgSrc) {
        updatedImgSrc = desktopImgSrc;
    }
    const handleImageClick = () => {
        if (on_click?.[0] && typeof on_click[0].funCall === "function") {
            on_click?.forEach(async (eachFunc: any) => {
                const payload = {
                    router,
                    ...eachFunc.args
                };
                eachFunc.funCall(payload);
            });
        }
    };

    const getStyles = () => {
        const Updatedstyles = { ...styles }
        if (mStyles && !isDesktop) {
            return { ...Updatedstyles, ...mStyles };
        }
        return Updatedstyles;
    };
    if(is_visible == false) return <></>;

    return (
        <ImageWrapper mStyles={mStyles}>
            <Img
                src={isResolvePath ? resolvePath(updatedImgSrc) : updatedImgSrc}
                height={styles?.height || "auto"}
                width={styles?.width || "auto"}
                style={getStyles()}
                onClick={handleImageClick}
                alt={alt}
            />
        </ImageWrapper>
    );
}
